import React, { Component, useRef, useEffect } from "react";
import 'styles/controls/CommonSelect.sass';

export default function CommonSelect(props) {
  const menu = useRef();

  useEffect(() => { 
    console.log('render CommonSelect ')
  });
  
  const toggleMenu = (ev) => {
    var aux = document.getElementById('setMinHeight').scrollHeight;
    if (menu.current.style.display == 'block'){
      //menu.current.style.display = 'none'
      closeMenus()
    }
    else{
      closeMenus()
      menu.current.style.display = 'block'
      if (document.getElementById('setMinHeight').scrollHeight > aux)
        document.getElementById("setMinHeight").style["min-height"] = (document.getElementById('setMinHeight').scrollHeight + 10)+ "px"
    }
    ev.stopPropagation()
  }

  const hideMenu = () => {
    menu.current.style.display = 'none'
    document.getElementById("setMinHeight").style["min-height"] = "0px"
  }

  function closeMenus(){
    for (var item of document.getElementsByClassName('selMenu')){
      item.style.display = 'none'
    }
    document.getElementById("setMinHeight").style["min-height"] = "0px"
  }

  const { title, current, buttons, opts } = props.content
  const {clickItem, enterItem, leaveItem} = props.funcs

  return (
    <div>
      <div className="selCont table" title={props.title}>
        <div className="row">
          <div className={"selBox cell noBut " + (opts.length == 0 ? "disabled" : "")} onClick={toggleMenu}> 
            <p className="selTit">{title}</p>
            <p className="selCurr">{current == "" ? "-" : current}</p>
            <div className="selTri">
              <svg viewBox='0 0 16 16'>
                <path fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/>
              </svg>
            </div>
          </div>
          {buttons.map((b) => (
            <div className={"selBut cell sel"+b.className} onClick={b.onClick} title={b.className == "Cat" ? "Link to Product/Dataset page":"Link to Producer page"}></div>
          ))}
        </div>
      </div>
      <div className="selOptsCont" onClick={hideMenu}>
        <div className="selOpts selMenu" ref={menu}>
          {opts.map((opt) => (
            <div className="selItem" id={opt[0]} onClick={clickItem} onMouseEnter={enterItem} onMouseLeave={leaveItem}>{opt[1]}</div>
          ))}
        </div>
      </div>
    </div>
  )
}